import axios from 'axios';
import { baseURL } from '../utility/Constants';

/**
 * @typedef {Object} InverterMetricsResponse
 * @property {string} emsName
 * @property {string} timeFilter
 * @property {string} startDate
 * @property {string} endDate
 * @property {Array<{
 *   timestamp: number,
 *   current: number,
 *   voltage: number,
 *   error: number,
 *   temp_ambient: number,
 *   temp_heatsink: number,
 *   data_points?: number,
 *   hour_timestamp?: number
 * }>} data
 */

/**
 * Fetches inverter metrics data
 * @param {string} emsName - The EMS name
 * @param {'daily' | 'weekly' | 'monthly'} timeFilter - Time filter for the data
 * @param {string} date - Date in YYYY-MM-DD format
 * @returns {Promise<InverterMetricsResponse>}
 */
export const fetchInverterMetrics = async (emsName, timeFilter, date) => {
  try {
    const response = await axios.post(`${baseURL}/inverter-metrics`, {
      emsName,
      timeFilter,
      date
    });
    
    return response.data;
  } catch (error) {
    console.error('Error fetching inverter metrics:', error);
    throw error;
  }
};
